// extracted by mini-css-extract-plugin
export default {"container":"UserFollowsInfo_container__dw4BK","divider":"UserFollowsInfo_divider__w6Tuo","section":"UserFollowsInfo_section__9lQxt"};